import get from 'lodash/get'
import each from 'lodash/each'
import isEmpty from 'lodash/isEmpty';

const maps = get(window, 'webbymaps.data.maps')

each(maps, function(mapData) {
    const mapId = get(mapData, 'id')
  
  const map = window.L.map('webbymaps-' + mapId, {
    attributionControl: true,
    scrollWheelZoom: false
  }) 

  const markers = get(mapData, 'config.markers')
  const markerCoordinates = []
  each(markers, markerData => {
      const latitude = get(markerData, 'latitude')
      const longitude = get(markerData, 'longitude')
      if (!!latitude && !!longitude && !isNaN(latitude) && !isNaN(longitude)) {
          markerCoordinates.push({ lat: latitude, lng: longitude })
      }
  })
  if (!isEmpty(markerCoordinates)) {
    const markerBounds = L.latLngBounds(markerCoordinates)
    map.fitBounds(markerBounds)
    const zoom = map.getZoom()
    // console.log('panning')
    // map.panBy([0, -300])
    map.setZoom(zoom - 1)

    // remove "Leaflet" attribution
    map.attributionControl.setPrefix('WebbyMaps')

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        // attribution: attribution
    }).addTo(map);

    const markerIconsType = get(mapData, 'config.markerIconsType')
        const markerIconsWidth = get(mapData, 'config.markerIconsWidth')
        const markerIconsHeight = get(mapData, 'config.markerIconsHeight')
        const markerIconsFileUrl = get(mapData, 'config.markerIconsFileUrl')
        const enableInfoWindows = get(mapData, 'config.enableInfoWindows')
        const infoWindowsContentType = get(mapData, 'config.infoWindowsContentType')
        const showInfoWindowsOn = get(mapData, 'config.showInfoWindowsOn')
        const infoWindowsCustomClass = get(mapData, 'config.infoWindowsCustomClass')

        markers.map((markerData, m) => {
            const latitude = get(markerData, 'latitude')
            const longitude = get(markerData, 'longitude')
            if (!!latitude && !!longitude && !isNaN(latitude) && !isNaN(longitude)) {
                const marker = L.marker({ lat: markerData.latitude, lng: markerData.longitude })
                    .addTo(map)

                if (markerIconsType === 'custom' && markerIconsFileUrl && markerIconsWidth && markerIconsHeight) {

                    const icon = L.icon({
                        iconUrl: markerIconsFileUrl,
                        iconSize: [markerIconsWidth, markerIconsHeight], // size of the icon
                        iconAnchor: [markerIconsWidth / 2, markerIconsHeight], // point of the icon which will correspond to marker's location // iconAnchor dihitung dari 0,0 atas kiri
                        popupAnchor: [0, markerIconsHeight * (-1)] // point from which the popup should open relative to the iconAnchor
                    })
                    marker.setIcon(icon)
                }

                if (enableInfoWindows) {
                    let infoWindowContent

                    if (infoWindowsContentType === 'default') {
                        const infoWindowLocationName = !!markerData.infoWindowLocationName ? markerData.infoWindowLocationName : 'Your Location'
                        const infoWindowLocationAddress = !!markerData.infoWindowLocationAddress ? markerData.infoWindowLocationAddress : 'Your Address and City'
                        const latitude = get(markerData, 'latitude')
                        const longitude = get(markerData, 'longitude')
                        const directionText = !!markerData.infoWindowDirectionText ? markerData.infoWindowDirectionText : 'Direction'
                        const directionLink = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`
                        infoWindowContent = `<b>${infoWindowLocationName}</b><p>${infoWindowLocationAddress}</p><a href="${directionLink}" target="_blank"><b>&#8618;</b> ${directionText}</a>`
                    } else if (infoWindowsContentType === 'custom') {
                        const infoWindowCustomContent = get(markerData, 'infoWindowCustomContent')
                        infoWindowContent = isEmpty(infoWindowCustomContent) ? 'Your custom info window content' : infoWindowCustomContent
                    }

                    marker.bindPopup(infoWindowContent, {
                        maxWidth: 275,
                        autoClose: false,
                        closeOnClick: false,
                        className: infoWindowsCustomClass
                    })
                }
                if (enableInfoWindows && showInfoWindowsOn === 'start') {
                    marker.openPopup()
                }
            }

        })
}

})



